import { injectable } from 'inversify';

import { NodeAction } from '@app/gen/events';

import { Validator } from '../responses';
import { VACATION_END_ATTR_ID } from '../events.constants';

@injectable()
export class EventsFormAttributesMapper {
  process(action: NodeAction, validators: Validator[], companyName: string) {
    const formattedValidators = validators.map((validator) => {
      if (validator.type === 'values_compare') {
        return {
          ...validator,
          from_attribute_id: validator.left_attribute_id,
          to_attribute_id: validator.right_attribute_id,
        };
      }

      return validator;
    });

    return action.form_attributes.map((attribute) => {
      const rangeValidators = formattedValidators.filter(
        (validator) =>
          ('from_attribute_id' in validator &&
            validator.from_attribute_id === attribute.id) ||
          ('to_attribute_id' in validator &&
            validator.to_attribute_id === attribute.id),
      );

      const relatedAttribute =
        rangeValidators
          .map((validator) => {
            if (
              'from_attribute_id' in validator &&
              validator.from_attribute_id === attribute.id
            ) {
              return validator.to_attribute_id;
            }
            if (
              'to_attribute_id' in validator &&
              validator.to_attribute_id === attribute.id
            ) {
              return validator.from_attribute_id;
            }
          })
          .find((value) => value) || '';

      const attributeType =
        rangeValidators
          .map((validator) => {
            if (
              'from_attribute_id' in validator &&
              validator.from_attribute_id === attribute.id
            ) {
              return 'rangeStart';
            }
            if (
              'to_attribute_id' in validator &&
              validator.to_attribute_id === attribute.id
            ) {
              return 'rangeEnd';
            }

            return 'single';
          })
          .find((value) => value) || 'single';

      const startValidator = formattedValidators.find(
        (validator) =>
          'from_attribute_id' in validator &&
          validator.from_attribute_id === attribute.id,
      );

      const endValidator = formattedValidators.find(
        (validator) =>
          'to_attribute_id' in validator &&
          validator.to_attribute_id === attribute.id,
      );

      return {
        ...attribute,
        relatedAttribute,
        companyName,
        attributeType,
        nameValidating: action.form_attributes.find((attr) => {
          if (endValidator) {
            return (
              'from_attribute_id' in endValidator &&
              attr.id === endValidator.from_attribute_id
            );
          } else if (startValidator) {
            return (
              'to_attribute_id' in startValidator &&
              attr.id === startValidator.to_attribute_id
            );
          } else {
            return attr.id === VACATION_END_ATTR_ID;
          }
        })?.name,
        validators: formattedValidators.filter(
          (validator) =>
            ('attribute_id' in validator &&
              validator.attribute_id === attribute.id) ||
            ('from_attribute_id' in validator &&
              validator.from_attribute_id === attribute.id) ||
            ('to_attribute_id' in validator &&
              validator.to_attribute_id === attribute.id),
        ),
      };
    });
  }
}
